module.exports = __webpack_public_path__ + "img/card_lanus_background.bd4f82a3.png";